var AbbDashboardModule = (function () {
    function AbbDashboardModule() {
    }
    return AbbDashboardModule;
}());
export { AbbDashboardModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.module.ts.pre-build-optimizer.js